import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {observer} from "mobx-react-lite";
import {notificationStore} from "../../stores/init";

export const RootNotificationComponent: React.FC = observer(() => {
    const handleClose = () => {
        if (notificationStore.active) {
            notificationStore.hide(notificationStore.active.id)
        }
    }

    const active = notificationStore.active;
    return <Snackbar
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        open={Boolean(active) && !active!.closed && !active!.hidden}>
        <Alert
            onClose={handleClose}
            severity={active?.severity || 'warning'}
            variant="filled"
            sx={{width: '100%'}}
        >
            {active?.message}
        </Alert>
    </Snackbar>
})
